import { useState } from "react";
import { Modal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import WarningIcon from "../../../svg/warningIcon";
import CustomCheckBox from "../../customCheckBox/customCheckBox";

interface TriggerRpaNewModalProps {
  onTriggerRpa: () => void;
  onClose: () => void;
}

const actionables = [
  {
    label: "Individual drug's auth status is up to date & correct.",
    value: "auth_status_up_to_date",
  },

  {
    label: "Notes are up to date with correct Dx Code, Auth ID.",
    value: "notes_up_to_date",
  },

  {
    label: "Radio button(s) selected is/are correct.",
    value: "radio_buttons_selected",
  },
];

const TriggerRpaNewModal = (props: TriggerRpaNewModalProps) => {
  const [selectedActionables, setSelectedActionables] = useState<string[]>([]);
  return (
    <Modal
      dialogId={ModalId.TRIGGER_RPA_MODAL_NEW}
      onSave={props.onTriggerRpa}
      title={"Comments RPA"}
      saveButtonText={"Trigger RPA"}
      cancelText={"Cancel"}
      onClose={props.onClose}
      onCancel={props.onClose}
      disableSave={selectedActionables.length < actionables.length}
    >
      <div className="trigger-rpa-new-model--container flex flex-col gap-4">
        <div className="trigger-rpa-mew-model--information flex items-center gap-2 bg-[#FAE6E6] p-2 text-small">
          <WarningIcon outerFillColor="black" height="16" width="16" />
          <div>
            Make sure you have completed the following, this step can't be {""}
            <span className="font-bold">reversed</span>
          </div>
        </div>
        <div className="trigger-rpa-new-model--actionables flex flex-col gap-3">
          <div className="header text-small">
            Select the actions that have been taken
          </div>
          <div className="actionables mb-4 flex flex-col gap-2">
            {actionables.map((actionable) => (
              <CustomCheckBox
                label={actionable.label}
                isChecked={selectedActionables.includes(actionable.value)}
                onCheckBoxValueChange={(data) => {
                  setSelectedActionables(
                    data.value
                      ? [...selectedActionables, data.name]
                      : selectedActionables.filter(
                          (actionable) => actionable !== data.name,
                        ),
                  );
                }}
                id={actionable.value}
                key={actionable.value}
                className="!mt-[3px] text-small"
              />
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TriggerRpaNewModal;
